// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const Container = styled.div`
  display: flex;
  padding: 16px;
`;

const Icon = styled.div`
  align-items: center;
  border-right: 1px solid ${colors.sand};
  color: ${colors.water};
  display: flex;
  font-size: 24px;
  margin-right: 16px;
  padding-right: 16px;
`;

const Title = styled.div`
  color: ${colors.smoke};
  font-size: 12px;
  font-weight: bold;
  padding-bottom: 8px;
`;

const Message = styled.div`
  font-size: 12px;
`;

type ToastProps = {
  icon: Node,
  message: string,
  title: string,
};

const Toast = ({ icon, message, title, ...props }: ToastProps) => (
  <Container {...props} data-bypass-dismiss-sidebar>
    <Icon>{icon}</Icon>
    <div>
      <Title>{title}</Title>
      <Message>{message}</Message>
    </div>
  </Container>
);

export default Toast;
